export default __webpack_public_path__ + "static/media/pin-icon.a964a614.svg";